export default __webpack_public_path__ + "static/media/logo.6efb5c00.svg";